// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./Components/RenderIf.bs.js";
import * as InputField$OrcaPaymentPage from "./Components/InputField.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./Utilities/JotaiAtoms.bs.js";
import * as WalletShimmer$OrcaPaymentPage from "./Components/WalletShimmer.bs.js";
import * as CardCVCElement$OrcaPaymentPage from "./CardCVCElement.bs.js";
import * as CardElementShimmer$OrcaPaymentPage from "./Components/CardElementShimmer.bs.js";
import * as PaymentElementShimmer$OrcaPaymentPage from "./Components/PaymentElementShimmer.bs.js";
import * as PaymentManagementLazy$OrcaPaymentPage from "./PaymentManagementLazy.bs.js";
import * as ReusableReactSuspense$OrcaPaymentPage from "./hyper-log-catcher/ReusableReactSuspense.bs.js";
import * as SingleLineCardPaymentLazy$OrcaPaymentPage from "./SingleLineCardPaymentLazy.bs.js";
import * as PaymentElementRendererLazy$OrcaPaymentPage from "./PaymentElementRendererLazy.bs.js";

function RenderPaymentMethods(props) {
  let isFocus = props.isFocus;
  let handleElementFocus = props.handleElementFocus;
  let cvcProps = props.cvcProps;
  let expiryProps = props.expiryProps;
  let cardProps = props.cardProps;
  let paymentType = props.paymentType;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let showLoader = match.showLoader;
  let match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let localeString = match$1.localeString;
  let themeObj = match$1.themeObj;
  let blur = props.blurState ? "blur(2px)" : "";
  let frameRef = React.useRef(null);
  let tmp;
  switch (paymentType) {
    case "Card" :
      tmp = JsxRuntime.jsx(ReusableReactSuspense$OrcaPaymentPage.make, {
        children: JsxRuntime.jsx(SingleLineCardPaymentLazy$OrcaPaymentPage.make, {
          paymentType: paymentType,
          cardProps: cardProps,
          expiryProps: expiryProps,
          cvcProps: cvcProps,
          zipProps: props.zipProps,
          handleElementFocus: handleElementFocus,
          isFocus: isFocus
        }),
        loaderComponent: JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
          condition: showLoader,
          children: JsxRuntime.jsx(CardElementShimmer$OrcaPaymentPage.make, {})
        }),
        componentName: "SingleLineCardPaymentLazy"
      });
      break;
    case "CardNumberElement" :
      tmp = JsxRuntime.jsx(InputField$OrcaPaymentPage.make, {
        isValid: cardProps.isCardValid,
        id: "card-number",
        setIsValid: cardProps.setIsCardValid,
        value: cardProps.cardNumber,
        onChange: cardProps.changeCardNumber,
        onBlur: cardProps.handleCardBlur,
        onFocus: handleElementFocus,
        type_: "tel",
        maxLength: cardProps.maxCardLength,
        placeholder: "1234 1234 1234 1234",
        inputRef: cardProps.cardRef,
        isFocus: isFocus,
        autocomplete: "cc-number"
      });
      break;
    case "CardExpiryElement" :
      tmp = JsxRuntime.jsx(InputField$OrcaPaymentPage.make, {
        isValid: expiryProps.isExpiryValid,
        id: "card-expiry",
        setIsValid: expiryProps.setIsExpiryValid,
        value: expiryProps.cardExpiry,
        onChange: expiryProps.changeCardExpiry,
        onBlur: expiryProps.handleExpiryBlur,
        onFocus: handleElementFocus,
        type_: "tel",
        maxLength: 7,
        placeholder: localeString.expiryPlaceholder,
        inputRef: expiryProps.expiryRef,
        isFocus: isFocus,
        autocomplete: "cc-exp"
      });
      break;
    case "CardCVCElement" :
      tmp = JsxRuntime.jsx(CardCVCElement$OrcaPaymentPage.make, {
        cvcProps: cvcProps,
        paymentType: paymentType
      });
      break;
    case "PaymentMethodsManagement" :
      tmp = JsxRuntime.jsx(ReusableReactSuspense$OrcaPaymentPage.make, {
        children: JsxRuntime.jsx(PaymentManagementLazy$OrcaPaymentPage.make, {
          paymentType: paymentType,
          cardProps: cardProps,
          expiryProps: expiryProps,
          cvcProps: cvcProps
        }),
        loaderComponent: JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
          condition: showLoader,
          children: JsxRuntime.jsx(PaymentElementShimmer$OrcaPaymentPage.make, {})
        }),
        componentName: "PaymentManagementLazy"
      });
      break;
    case "PaymentMethodsSDK" :
    case "PaymentMethodCollectElement" :
    case "NONE" :
      tmp = null;
      break;
    default:
      tmp = JsxRuntime.jsx(ReusableReactSuspense$OrcaPaymentPage.make, {
        children: JsxRuntime.jsx(PaymentElementRendererLazy$OrcaPaymentPage.make, {
          paymentType: paymentType,
          cardProps: cardProps,
          expiryProps: expiryProps,
          cvcProps: cvcProps
        }),
        loaderComponent: JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
          condition: showLoader,
          children: Utils$OrcaPaymentPage.checkIsWalletElement(paymentType) ? JsxRuntime.jsx(WalletShimmer$OrcaPaymentPage.make, {}) : JsxRuntime.jsx(PaymentElementShimmer$OrcaPaymentPage.make, {})
        }),
        componentName: "PaymentElementRendererLazy"
      });
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        children: tmp,
        className: "w-full font-medium"
      }),
      ref: Primitive_option.some(frameRef),
      className: `m-auto flex justify-center md:h-auto  w-full h-auto `
    }),
    className: `flex flex-col justify-between PaymentMethodContainer`,
    dir: localeString.localeDirection,
    style: {
      background: "transparent",
      color: themeObj.colorText,
      filter: blur,
      fontFamily: themeObj.fontFamily,
      fontSize: themeObj.fontSizeBase,
      marginBottom: "4px",
      marginLeft: "4px",
      marginRight: "4px",
      marginTop: "4px"
    }
  });
}

let make = RenderPaymentMethods;

export {
  make,
}
/* jotai Not a pure module */
